// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"2ef45175","48":"ae3a2f5c","419":"fa30a0a9","563":"706cda93","942":"e04ae9ec"}[chunkId] + ".chunk.js";
};